import React, { useContext, useEffect, useState, useRef } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { AuthContext } from "../../../context/AuthContext";
import "../pages/home/Home.css";
import Spinner from "react-bootstrap/Spinner";
import FetchService from '../../../utils/FetchService';
import { Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import PdfViewerModal from '../../../components/modals/PdfViewerModal';
import { fetchBlobFile } from "../../../utils/FetchBlobFile";

function CertificacionNotificaciones() {
  const { user } = useContext(AuthContext);
  const [biToken, setBiToken] = useState("");
  const [showFABs, setShowFABs] = useState(false);
  const [fileName, setFileName] = useState("");
  const clientKey = process.env.REACT_APP_PDF_VIEWER_KEY;

  const isAdmin =
    user.userInfo.account.username.search("@admin.strabpr.com") > 0 ||
    user.userInfo.account.username === "jlondono@softekpr.com";

  const reportRef = useRef(null);

  useEffect(() => {
    FetchService.fetchData(
      `?rt=11&ut=${isAdmin ? 99 : 11}`,
      { headers: { "Authorization": `Bearer ${user.userInfo.accessToken}` } }
    )
    .then(res => setBiToken(res.data))
    .catch(console.error);
  }, [isAdmin, user]);

  const onEmbedded = (embeddedReport) => {
    reportRef.current = embeddedReport;
    embeddedReport.on("dataSelected", handleDataSelected);
    embeddedReport.on("selectionChanged", handleClickOutside);
  };

  function handleDataSelected(event) {
    const pts = event.detail?.dataPoints || [];
    if (pts.length > 0) {
      const candidate = pts[0].identity?.[5]?.equals;
      if (typeof candidate === "string" && (/^\d+\/.*\.pdf$/.test(candidate) || /^\d+\/.*\.html$/.test(candidate))) {
        setFileName(candidate);
        setShowFABs(true);
        return;
      }
    }
    setShowFABs(false);
  }

  // Manejar clic fuera de la tabla para ocultar FABs y limpiar selección
  const handleClickOutside = async (event) => {
    if (!event.detail.visual) {
      setShowFABs(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleDownloadFile = async () => {
    try {
      const fileBlob = await fetchBlobFile(fileName, clientKey);
      const fileUrl = URL.createObjectURL(fileBlob);
      const a = document.createElement("a");
      const parts = fileName.split("/");
      const fileNameToDownload = parts[parts.length - 1]; // Obtiene el último elemento después del slash

      a.href = fileUrl;
      a.download = fileNameToDownload; // Nombre del archivo a descargar
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  return (
    <form>
      {biToken ? (
        <>
          <div style={{ position: "relative" }}>
            <PowerBIEmbed
              embedConfig={{
                type: "report", // Supported types: report, dashboard, tile, visual and qna
                id: "d2272b95-75a1-45b0-9135-7c517a5d96b2",
                embedUrl:
                  "https://app.powerbi.com/reportEmbed?reportId=d2272b95-75a1-45b0-9135-7c517a5d96b2&groupId=e8f0ad8a-895f-4495-991b-56d4c3509784&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19",
                accessToken: biToken,
                tokenType: models.TokenType.Embed,
                pageView: models.PageSizeType.Cortana,
                settings: {
                  navContentPaneEnabled: false,
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                  },
                },
              }}
              getEmbeddedComponent={onEmbedded}
              cssClassName="Embed-container"
            />
          </div>
          {/* Floating Action Buttons con animaciones CSS */}
          <div className={`fab-container ${showFABs ? "show" : ""}`}>
            <PdfViewerModal fileName={fileName} clientKey={clientKey} />
            <Button variant="success" className="fab-button" onClick={handleDownloadFile}>
              <FaDownload size={20} />
            </Button>
          </div>
        </>
      ) : (
        <div className="home">
          <Spinner variant="primary" animation="border" role="status" style={{ width: "6rem", height: "6rem" }}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </form>
  );
}

export default CertificacionNotificaciones;